// extracted by mini-css-extract-plugin
module.exports = {"brandLink":"BrandsCarousel_brandLink__lFnGI"};